import { render, staticRenderFns } from "./ImageAssetSelect.vue?vue&type=template&id=a25cbd44&scoped=true"
import script from "./ImageAssetSelect.vue?vue&type=script&lang=js"
export * from "./ImageAssetSelect.vue?vue&type=script&lang=js"
import style0 from "./ImageAssetSelect.vue?vue&type=style&index=0&id=a25cbd44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a25cbd44",
  null
  
)

export default component.exports